package songwritersnotebook.app.screens.components


import songwritersnotebook.app.screens.*

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.tween
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.LinearEasing
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.TextLayoutResult
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.input.KeyboardCapitalization
import kotlinx.coroutines.delay
import kotlinx.coroutines.withTimeoutOrNull
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.foundation.gestures.waitForUpOrCancellation
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.gestures.detectHorizontalDragGestures
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import songwritersnotebook.app.utils.NetworkUtils
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.MenuBook
import androidx.compose.material.icons.automirrored.filled.Send
import androidx.compose.material.icons.automirrored.filled.Undo
import androidx.compose.material.icons.automirrored.filled.Redo
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.zIndex
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.unit.DpSize
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.material.icons.filled.CloudDone
import androidx.compose.material.icons.filled.Save
import androidx.compose.material.icons.filled.Piano
import androidx.compose.material.icons.filled.Check
import songwritersnotebook.app.utils.rememberMicPermissionLauncher
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.MusicNote
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.geometry.CornerRadius
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import songwritersnotebook.app.billing.SubscriptionTier
import songwritersnotebook.app.billing.ProductInfo
import songwritersnotebook.app.data.*
import songwritersnotebook.app.navigation.AppRoutes
import songwritersnotebook.app.ui.theme.BlueAccent
import songwritersnotebook.app.ui.theme.GoldAccent
import songwritersnotebook.app.ui.theme.SliderThumbGray
import songwritersnotebook.app.ui.theme.SliderTrackGray
import songwritersnotebook.app.ui.theme.ChordVisualTransformation
import songwritersnotebook.app.utils.countSyllables
import songwritersnotebook.app.viewmodels.*
import kotlinx.datetime.*
import org.jetbrains.compose.resources.painterResource
import songwritersnotebookapp.composeapp.generated.resources.Res
import songwritersnotebookapp.composeapp.generated.resources.ic_guitar
import songwritersnotebook.app.ui.theme.SuccessGreen
import songwritersnotebook.app.components.SaveStatusIndicator
import songwritersnotebook.app.adaptiveSheetWidth
import songwritersnotebook.app.components.ChordPanel
import songwritersnotebook.app.components.ChordCreatorSheet
import songwritersnotebook.app.components.HarmonyAiTabContent
import songwritersnotebook.app.components.TabEditorSheet
import songwritersnotebook.app.components.RecordingSheet
import songwritersnotebook.app.components.LineMediaSheet
import songwritersnotebook.app.components.TabDisplay
import songwritersnotebook.app.components.LoadingOverlay
import songwritersnotebook.app.tutorial.TutorialManager
import songwritersnotebook.app.tutorial.TutorialStep
import songwritersnotebook.app.tutorial.tutorialTarget
import androidx.compose.material3.SegmentedButton
import androidx.compose.material3.SegmentedButtonDefaults
import androidx.compose.material3.SingleChoiceSegmentedButtonRow
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.rememberScrollState
import songwritersnotebook.app.tutorial.TutorialOverlay
import songwritersnotebook.app.LocalPlatformContext
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.type
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.unit.IntOffset
import songwritersnotebook.app.components.VersionHistorySheet


@OptIn(androidx.compose.foundation.layout.ExperimentalLayoutApi::class)
@Composable
fun InstrumentInfoHeader(
    song: Song,
    settings: EditorSettings,
    chordsInUse: Set<String>
) {
    val showPiano = settings.showPianoInfo
    val showGuitar = settings.showGuitarInfo
    if (!showPiano && !showGuitar) return
    Column(modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 8.dp).border(width = 1.dp, color = MaterialTheme.colorScheme.outlineVariant, shape = RoundedCornerShape(8.dp)).padding(12.dp)) {
        if (showGuitar) {
            Text("Guitar Information", style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold)
            Spacer(modifier = Modifier.height(8.dp))
            Text("Tuning: ${song.guitarTuning.joinToString(" ")}", fontFamily = FontFamily.Monospace, fontSize = 12.sp)
            if (song.guitarCapo > 0) Text("Capo: ${song.guitarCapo}", fontFamily = FontFamily.Monospace, fontSize = 12.sp)
            
            if (chordsInUse.isNotEmpty()) {
                Spacer(modifier = Modifier.height(8.dp))
                FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    chordsInUse.sorted().forEach { chordName ->
                        val def = song.chordDefinitions[chordName]
                        val tab = def?.guitarTab ?: songwritersnotebook.app.utils.ChordUtils.GUITAR_CHORD_TABS[chordName]?.map { it.toString() }
                        if (tab != null) {
                            Text("$chordName: ${tab.joinToString("-")}", fontFamily = FontFamily.Monospace, fontSize = 12.sp)
                        }
                    }
                }
            }
        }
        
        if (showPiano && showGuitar) HorizontalDivider(modifier = Modifier.padding(vertical = 8.dp))
        
        if (showPiano) {
            Text("Piano Information", style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold)
            Spacer(modifier = Modifier.height(8.dp))
            if (chordsInUse.isNotEmpty()) {
                chordsInUse.sorted().forEach { chordName ->
                    val def = song.chordDefinitions[chordName]
                    val notes = def?.pianoNotes ?: songwritersnotebook.app.utils.ChordUtils.PIANO_CHORD_VOICINGS[chordName] 
                    ?: run {
                        val (root, quality) = songwritersnotebook.app.utils.ChordUtils.parseChordName(chordName)
                        songwritersnotebook.app.utils.ChordUtils.calculateChordNotes(root, quality)
                    }
                    if (notes.isNotEmpty()) {
                        Text("$chordName: ${notes.joinToString(", ")}", fontFamily = FontFamily.Monospace, fontSize = 12.sp)
                    }
                }
            }
        }
    }
}


@Composable
fun SongNotesCard(notes: String) {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp, vertical = 8.dp),
        shape = RoundedCornerShape(12.dp),
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.secondaryContainer.copy(alpha = 0.3f)
        ),
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.secondary.copy(alpha = 0.2f))
    ) {
        Column(modifier = Modifier.padding(16.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(
                    Icons.Default.Description, 
                    contentDescription = null, 
                    modifier = Modifier.size(18.dp),
                    tint = MaterialTheme.colorScheme.secondary
                )
                Spacer(Modifier.width(8.dp))
                Text(
                    "Notes",
                    style = MaterialTheme.typography.labelLarge,
                    fontWeight = FontWeight.Bold,
                    color = MaterialTheme.colorScheme.secondary
                )
            }
            Spacer(Modifier.height(8.dp))
            Text(
                text = notes,
                style = MaterialTheme.typography.bodyMedium,
                lineHeight = 20.sp,
                color = MaterialTheme.colorScheme.onSecondaryContainer
            )
        }
    }
}


@Composable
fun SongNotesDialog(
    initialNotes: String,
    onDismiss: () -> Unit,
    onSave: (String) -> Unit
) {
    var notes by remember { mutableStateOf(initialNotes) }

    AlertDialog(
        onDismissRequest = onDismiss,
        title = { 
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Default.Description, null, tint = MaterialTheme.colorScheme.primary)
                Spacer(Modifier.width(12.dp))
                Text("Song Notes")
            }
        },
        text = {
            Column(modifier = Modifier.fillMaxWidth()) {
                Text(
                    "Add instructions, amp settings, or other details for this song.",
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant
                )
                Spacer(Modifier.height(16.dp))
                OutlinedTextField(
                    value = notes,
                    onValueChange = { if (it.length <= 5000) notes = it },
                    modifier = Modifier
                        .fillMaxWidth()
                        .heightIn(min = 200.dp, max = 400.dp),
                    placeholder = { Text("e.g. Gain: 6, Treble: 7, Use neck pickup...") },
                    shape = RoundedCornerShape(12.dp),
                    textStyle = MaterialTheme.typography.bodyMedium
                )
                Text(
                    text = "${notes.length}/5000",
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.outline,
                    modifier = Modifier.align(Alignment.End).padding(top = 4.dp)
                )
            }
        },
        confirmButton = {
            Button(onClick = { onSave(notes) }) {
                Text("Save")
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text("Cancel")
            }
        },
        modifier = Modifier.adaptiveSheetWidth()
    )
}


